import {Component, Input, OnInit} from '@angular/core';
import {Period} from '../../../generated/sales-terminal-client';
import {ViewService} from '../../../services/view/view.service';
import {UtilService} from '../../../services/util/util.service';

@Component({
  selector: 'app-event-info-props-period',
  templateUrl: './event-info-props-period.component.html'
})
export class EventInfoPropsPeriodComponent implements OnInit {
  @Input() period: Period;
  @Input() timezone: string;
  @Input() icon: string = 'calendar';
  @Input() iconTooltip: string = '';
  @Input() showWeekday: boolean;
  @Input() muted: boolean;
  @Input() alignRight: boolean;

  public isPeriodSameDay: boolean;

  constructor(public viewService: ViewService,
              public utilService: UtilService) {
  }

  public ngOnInit(): void {
    this.isPeriodSameDay = this.period?.end && this.utilService.isPeriodSameDay(this.period?.start, this.period?.end);
  }
}
